import React, { useState } from "react";
import { TextField, Grid, Paper, Button, Backdrop, CircularProgress, Alert, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import { getAuthenticationToken } from '../utils/TokenHandler';
import MaterialNotifyComponent from "./MaterialNotifyComponent";
import { withRouter } from 'react-router-dom';
import { getUserProfile } from "../utils/userProfile";

function CustomerAddToolsSerialForm(props) {
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [open, setOpen] = useState(false);
    const [serialCode, setSerialCode] = useState('');
    const [customerType, setCustomerType] = useState(0);

    const useStyles = makeStyles(theme => ({
        root: {
            "& .MuiFormLabel-root": {
                right: 0, // or black
                left: 'unset'
            }, "& .MuiSvgIcon-root": {
                position: 'inherit'
            }
        }
    }));

    const classes = useStyles();
    const formElementStyle = {
        margin: "10px 0"
    };
    const paperStyle = {
        padding: 20,
        height: 'max-content',
        width: '70vw',
        margin: 'auto'
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setOpen(true);
        axios.post('/api/v1/Stuff/AddCustomerStuffSerialNumber', {
            customerId: getAuthenticationToken().userID,
            serialNumber: serialCode,
            customerType: customerType
        }).then(response => {
            setMessageNotify({
                severity: response.data.success ? "success" : "warning",
                message: response.data.warningMessage,
                open: true
            });
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در ثبت شماره سریال",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        });
    }

    return (
        <>
            <Alert variant="filled" severity="info" icon={false} style={{ marginBottom: '10px' }}>
                جهت فعال سازی گارانتی 24 ماهه و کسب امتیاز لطفا شماره سریال روی محصول را وارد نمادید
            </Alert>
            <form onSubmit={handleSubmit}>
                <Paper elevation={10} style={paperStyle} >
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <TextField
                                style={formElementStyle}
                                className={classes.root}
                                id="postalCode"
                                name="postalCode"
                                label="کد سریال محصول"
                                fullWidth
                                variant="standard"
                                value={serialCode}
                                onChange={e => setSerialCode(e.target.value)} />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormLabel id="demo-row-radio-buttons-group-label">لطفا انتخاب کنید</FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                onChange={e => setCustomerType(e.target.value)}
                            >
                                <FormControlLabel value="0" control={<Radio />} label="خریدار محصولات NEC هستم" />
                                <FormControlLabel value="1" control={<Radio />} label="فروشنده محصولات NEC هستم" />
                            </RadioGroup>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Button
                                id="submit"
                                type='submit'
                                name="submit"
                                fullWidth
                                variant="contained"
                                color="success" >ثبت کد سریال محصول</Button>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Button
                                onClick={() => { props.history.push('/') }}
                                id="cancel"
                                name="cancel"
                                fullWidth
                                variant="outlined"
                                color="error" >انصراف</Button>
                        </Grid>
                    </Grid>
                </Paper>
            </form>
            <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default withRouter(CustomerAddToolsSerialForm);